<!--
 * @Author: zhonghao
 * @Date: 2024-08-20 08:23:56
-->
<template>
  <div v-if="fromType !== 'case'">
    <img src="../../../assets/images/common/icon-back2.png" v-if="curPath === '/courserDetails'" @click="handleReturn" class="icon-back" alt="">
    <img src="../../../assets/images/common/ic_back.png" v-if="curPath !== '/courserDetails'" @click="handleReturn" class="icon-back" alt="">
  </div>
</template>
<script>
import { setSha, traceClickURL } from '@/utils/util'
export default {
  data() {
    return {
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    curPath () {
      return this.$route.path
    },
    fromType() {
      return this.$route.query.fromType
    }
  },
  methods: {
    handleReturn() {
      if (this.$route.query.entrancePage === 'search') {
        if (window.history.length > 1) {
          this.$router.back()
        } else {
          this.$router.replace('/home')
        }
        return
      }
      if (this.$route.path === '/courserDetails') {
        if (this.$route.query.classId > 0) { // 班级课程返回
          return this.$router.go(-1)
        }
        this.$router.push({
          path: '/home',
        })
      } else {
        if (this.$route.query.areaId > 0) {
          if (this.$route.query.type === 'dcc') {
            this.$router.go(-1)
          } else {
            this.$router.push({
              path: '/zoneDetails',
              query: {
                areaId: this.$route.query.areaId
              }
            })
          }
        } else {
          if (this.$route.query.type === 'dcc') {
            this.$router.go(-1)
          } else if (this.$route.query.fromType === 'ecg') {
            this.$router.go(-1)
          } else {
            setTimeout(() => { traceClickURL() })
            let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
            window.location.href = `${process.env.bingliUrl}/wap/index.html#/homePage?listType=4${openidBindli}`
          }
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.icon-back {
  width: 41px;
  height: 41px;
  position: fixed;
  right: 18px;
  bottom: 147px;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/returnBack.vue